import { Controller } from "@hotwired/stimulus";
import html2canvas from 'html2canvas'

export default class extends Controller {
  static targets = ["preview", "link"];

  async capture() {
    const restoreIcons = await this.replaceMaskIconsWithCanvas();

    try {
      html2canvas(this.previewTarget, {
        allowTaint: true,
        scale: 2,
        useCORS: true
      }).then(canvas => {
        this.linkTarget.href = canvas.toDataURL();

        const link = this.buildLinkTag(canvas.toDataURL());
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    } finally {
      restoreIcons();
    };
  };

  // icons use css mask but html2canvas does not support them
  //  replace them with canvases and restore them after download the image
  replaceMaskIconsWithCanvas() {
    const icons = Array.from(
      this.previewTarget.getElementsByClassName('design_setting_icon_color-as-background-color')
    );

    if (icons.length === 0) {
      return Promise.resolve(() => {});
    };

    const replacements = [];

    const loadPromises = icons.map((icon) => {
      const maskValue = icon.style.mask;
      const match = maskValue && maskValue.match(/url\((.*?)\)/);
      if (!match) return Promise.resolve();

      const iconImageUrl = match[1].replace(/['"]/g, "");
      const parent = icon.parentElement;
      const canvas = this.createCanvas(icon);
      
      return new Promise((resolve) => {
        const img = new Image();

        img.crossOrigin = "anonymous";
        img.onload = () => {
          this.drawImageOnCanvas(canvas, icon, img)
          parent.appendChild(canvas);
          replacements.push({ icon, canvas });
          resolve();
        };

        img.onerror = () => {
          console.error("Failed to load icon for preview capture (CORS?):", iconImageUrl);
          resolve();
        };

        img.src = iconImageUrl;
      });
    });

    return Promise.all(loadPromises).then(() => {
      return () => {
        replacements.forEach(({ icon, canvas }) => {
          canvas.remove();
          icon.style.display = "";
        });
      };
    });
  };

  drawImageOnCanvas(canvas, icon, img) {
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = icon.style.backgroundColor || "#000000";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    icon.style.display = "none";
  }

  createCanvas(icon) {
    const size = parseInt(icon.style.width, 10) || 40;
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    canvas.style.cssText = icon.style.cssText;
    canvas.style.mask = null;
    canvas.style.backgroundColor = null;

    return canvas;
  };

  buildLinkTag(canvasUrl) {
    var link = document.createElement('a');
    link.download = 'preview';
    link.href = canvasUrl;

    return link;
  };
};